import { Box, Typography } from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import WebsiteIcon from '@material-ui/icons/Language';
import TwitterIcon from '@material-ui/icons/Twitter';
import { Skeleton } from '@material-ui/lab';
import type { ArtistData } from '@mogul/api-client';
import React from 'react';

import DefaultAvatar from '../../common/images/profile-pic-empty.png';
import discordIcn from '../../common/svg/launchpad/Discord-Logo-White.svg';
import imdbIcon from '../../common/svg/launchpad/imdb-icon.svg';
import { RichText } from '../../components/launchpad/RichText.component';
import styles from './Artists.module.css';
interface SocialProps {
  social: string;
  link: string;
}

const SocialMediaIcon = ({ social, link }: SocialProps) => {
  let icon;
  switch (social) {
    case 'instagram':
      icon = <InstagramIcon />;
      break;
    case 'facebook':
      icon = <FacebookIcon />;
      break;
    case 'twitter':
      icon = <TwitterIcon />;
      break;
    case 'discord':
      icon = (
        <img className="h-6 w-6 mx-1" src={discordIcn} alt={'discordIcn'} />
      );
      break;
    case 'imdb':
      icon = <img className="h-10 w-10 mx-1" src={imdbIcon} alt={'imdbIcn'} />;
      break;
    default:
      icon = <WebsiteIcon />;
      break;
  }

  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={link}
      className={styles.socialIcon}
    >
      <div className="flex items-center">{icon}</div>
    </a>
  );
};

export interface ArtistsProps {
  artists: ArtistData[];
}

export const Artists: React.FC<ArtistsProps> = props => {
  const { artists } = props;

  const parseSocials = (social: any) => {
    return (
      <div className="flex">
        {Object.keys(social).map((socialMedia: string) => {
          return (
            <div className="ml-2 self-center" key={socialMedia}>
              <SocialMediaIcon
                social={socialMedia}
                link={social[socialMedia]}
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="w-auto">
      <div
        className={`${styles.sectionHeader} sm:mx-0 mx-10 fontVanguard font-bold pb-5`}
      >
        Artists / Team
      </div>
      {!artists.length ? (
        <Box className="w-full">
          <Skeleton variant="rect" height={300} />
        </Box>
      ) : (
        <div className="w-full flex flex-wrap justify-around">
          {artists.map(artist => (
            <Box
              key={artist.id}
              className="w-80 mx-5 sm:mx-2 lg:my-5 flex flex-col justify-start my-5"
              style={{ display: 'flex' }}
            >
              {artist.profileImageUrl !== '' &&
                artist.profileImageUrl !== null && (
                  <div
                    className="m-5 lg:m-8 sm:m-2"
                    style={{ maxWidth: '250px', maxHeight: '250px' }}
                  >
                    {/* eslint-disable-next-line jsx-a11y/alt-text */}
                    <img
                      className={styles.image}
                      src={artist.profileImageUrl}
                    />
                  </div>
                )}

              <div className="mx-5 lg:mx-8 sm:mx-2">
                <div className={styles.nameHeader}>
                  {artist.name}
                  {parseSocials(artist.social)}
                </div>
                <div className="w-full sm:mx-auto">
                  <RichText
                    removeTitle={true}
                    content={artist.richTextDescription ?? {}}
                  />
                </div>
              </div>
            </Box>
          ))}
        </div>
      )}
    </div>
  );
};
